import { PaymentStrategy } from '@ctct/state-server-layer';

import type { PaymentMethodsManager } from '../../managers';
import type { EventConnection } from '../EventBus';
import type { Listeners } from '../InitializerHelpers';

class ControllerHelpers {
  public createListeners = (eventConnections: EventConnection[]): Listeners => {
    return {
      on: () => {
        eventConnections.forEach((connection) => connection.on());
      },
      off: () => {
        eventConnections.forEach((connection) => connection.off());
      },
    };
  };

  /**
   * Handles Stripe payment failure recovery by refreshing payment methods
   * and appending a user-friendly message if refresh fails.
   * See CBU-20304
   */
  public handleStripePaymentError = async (
    error: Error,
    paymentMethodsApi: Awaited<ReturnType<PaymentMethodsManager['getApiWhenReady']>>
  ): Promise<string> => {
    let errorMessage = error.message;

    if (paymentMethodsApi.paymentStrategy === PaymentStrategy.Stripe) {
      const refreshSucceeded = await paymentMethodsApi.handleStripePaymentFailure();

      if (!refreshSucceeded) {
        errorMessage += ' If you continue to experience issues, please refresh the page and try again.';
      }
    }

    return errorMessage;
  };
}

export const controllerHelpers = new ControllerHelpers();
